import React, { useEffect } from "react";
import "./Terms.css";

export default function PrivacyPolicy(): JSX.Element {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <main className="terms-page">
      <section className="terms-hero">
        <div className="terms-hero-inner">
          <h1>Privacy Policy</h1>
          <p>
            Jortel&#39;s Privacy Policy is available below for review and
            download.
          </p>
        </div>
      </section>

      <section className="terms-body">
        <div className="terms-card">
          <h2>Privacy Policy</h2>
          <p className="terms-note">
            View the full policy here, or download a copy for your records.
          </p>
          <div className="terms-doc">
            <iframe
              className="terms-iframe"
              src="/docs/Privacy%20Policy.pdf"
              title="Jortel Privacy Policy"
            />
          </div>
          <a
            className="terms-download"
            href="/docs/Privacy%20Policy.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Download Privacy Policy (PDF)
          </a>
        </div>
      </section>
    </main>
  );
}
